import { Client } from 'dsteem'
import Config from '@/config.js'
import Alerts from '@/mixins/Alerts.js'

export default {

  data: function(){
    return {
      sending: false,
      aborting: false,
      onNodeProgress: null,
      abortNodeConnection: false
    }
  },

  mixins: [
    Alerts
  ],

  created() {
    let self = this
    this.onNodeProgress = {
      abort() {
        if(self.abortNodeConnection) {
          console.log('Connection with the RPC node was aborted')
          return true
        }
        return false
      },
      onInit() {
        self.abortNodeConnection = false
      },
      onFail(event) {
        var number = event.fails>1 ? ' ('+event.fails+')' : ''
        self.showInfo('Connection problems. Trying to reconnect'+number+'...')
      },
      onChangeNode(event) {
        self.showInfo('Changing to node '+event.rpc_node)
      },
      onFailRound(event) {
        var number = event.failRounds>1 ? ' ('+event.failRounds+')' : ''
        self.showInfo('Connection problems with all RPC nodes. Trying again'+number+'...')
      },
      // eslint-disable-next-line no-unused-vars
      onSuccess(response) {
        self.hideInfo()
      },
      onError(error) {
        self.hideInfo()
        self.showDanger(error.message)
      },
      // eslint-disable-next-line no-unused-vars
      onAbort(event) {
        self.hideInfo()
        self.aborting = false
      }
    }
  },

  methods: {
    RPCnode_initClient(address = this.$store.state.rpc_node) {
      let opts = {}
      opts.addressPrefix = Config.BLURT_ADDRESS_PREFIX
      opts.timeout = Config.DBLURT_TIMEOUT
      if(Config.BLURT_CHAIN_ID) opts.chainId = Config.BLURT_CHAIN_ID
      return new Client(address, opts)
    },

    RPCnode_setMaxFails(max_fails) {
      this.$store.state.max_fails = max_fails
    },

    RPCnode_setMaxFailRounds(max_fail_rounds) {
      this.$store.state.max_fail_rounds = max_fail_rounds
    },

    RPCnode_fail(event, error) {
      console.log(`Fail RPC node: ${error.message}`)
      event.status = 'fail'
      event.fails++
      if(event.fails >= this.$store.state.max_fails) {
        //change node
        var id = Config.RPC_NODES.findIndex( (rpc)=> {return rpc === event.rpc_node} ) + 1

        event.status = 'change_node'

        if(id == Config.RPC_NODES.length){
          //all nodes failed. fail_rounds++
          console.log('Fail round RPC node')
          event.status = 'fail_round'
          id = 0

          event.fail_rounds++
          if(event.fail_rounds >= this.$store.state.max_fail_rounds) {
            //all nodes failed in all rounds. Error
            error = new Error('Connection error with the RPC node')
            error.name = 'RPCFailRounds'
            throw error
          }
        }
        event.rpc_node = Config.RPC_NODES[id]
        event.fails = 0
        console.log('Changing to node '+event.rpc_node)
      }
      return event
    },

    async RPCnode_request( request, lambda ) {

      if(lambda.onInit) lambda.onInit()

      var event = {
        status:          'init',
        rpc_node:        this.$store.state.rpc_node,
        fails:           0,
        fail_rounds:     0,
        max_fails:       this.$store.state.max_fails,
        max_fail_rounds: this.$store.state.max_fail_rounds,
      }
      var lastStableRPC = this.$store.state.rpc_node

      // eslint-disable-next-line no-constant-condition
      while(true) {
        try{
          if(lambda.abort && lambda.abort()) break

          var client = this.RPCnode_initClient(event.rpc_node)
          if(lastStableRPC !== this.$store.state.rpc_node){
            lastStableRPC = this.$store.state.rpc_node
            client = this.RPCnode_initClient(lastStableRPC)
            console.log('Taking a stable RPC node: '+lastStableRPC)
          }

          var response = await request(client)

          this.$store.state.rpc_node = event.rpc_node

          if(lambda.onSuccess) lambda.onSuccess(response)
          return response
        }catch(error){
          if(error.name === 'RPCError') {
            if(lambda && lambda.onError) lambda.onError(error)
            throw error
          }

          try {
            event = this.RPCnode_fail(event, error) //this function could throw an error to break the while loop
          } catch(err) {
            if(lambda && lambda.onError) lambda.onError(err)
            throw err
          }

          if(lambda.onFail       && event.status === 'fail'       ) lambda.onFail(event)
          if(lambda.onChangeNode && event.status === 'change_node') lambda.onChangeNode(event)
          if(lambda.onFailRound  && event.status === 'fail_round' ) lambda.onFailRound(event)
        }
      }

      if(lambda.onAbort) lambda.onAbort(event)
      var error = new Error('Connection aborted')
      error.name = 'Abort'
      throw error
    },

    async blurt_database_call( method, params ) {
      return this.RPCnode_request( async function(client){
        return await client.database.call(method, params)
      }, this.onNodeProgress)
    },

    // async blurt_broadcast_comment( comment, privKey, lambda ) {
    //   return this.RPCnode_request( async function(client){
    //     return await client.broadcast.comment(comment, privKey)
    //   }, this.onNodeProgress)
    // },

    // async blurt_broadcast_sendOperations( operations,privKey, lambda ) {
    //   return this.RPCnode_request( async function(client){
    //     return await client.broadcast.sendOperations(operations, privKey)
    //   }, this.onNodeProgress)
    // },

    // async blurt_broadcast_send( trx ) {
    //   return this.RPCnode_request( async function(client){
    //     return await client.broadcast.send(trx)
    //   }, this.onNodeProgress)
    // }
  }
}
